import React from 'react';
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';
import { Avatar } from 'eymp-uicomps';
import LabelValue from 'eymp-uicomps/components/LabelValue';
import Spinner from 'src/ui/library/Spinner/Spinner';
import _ from 'lodash';
import { MESSAGING_COMPOSE_AUTOFILL_URL } from 'src/constants/constants';
import urlParamsMapper from 'src/helpers/urlParamsMapper.js';
import { setComposeClick } from '../state/newDashboardAction';
import intl from 'react-intl-universal';

class ContactsPres extends React.Component {
  componentDidMount() {}
  componentWillUnmount() {}

  onEmailClick = contact => {
    // this.props.setComposeClick(true);
    window.location.href = urlParamsMapper(MESSAGING_COMPOSE_AUTOFILL_URL, {
      contactId: contact.profileId,
      caseId: contact.caseId,
      entityType: contact.entityType,
    });
  };
  getContent() {
    const { contactList } = this.props.contacts;
    if (!contactList || contactList.length === 0) {
      return intl.get('newDashboard.common.noItemtoDisplay');
    }
    return _.map(contactList, item => (
      <React.Fragment>
        <Grid item md={3} lg={3} className="contact-avatar-wrapper">
          <Avatar firstName={item.firstName} lastName={item.lastName} color="Green" />
        </Grid>
        <Grid item md={9} lg={9} className="label-text-info">
          <div>{item.caseRole}</div>
          <div>{item.fullName}</div>
          <div className="cursor-pointer" onClick={() => this.onEmailClick(item)}>
            {item.email.toLowerCase()}
          </div>
        </Grid>
      </React.Fragment>
    ));
  }

  render() {
    return (
      <Grid item sm={12}>
        <Grid className="header-wrap">
          <LabelValue value="CONTACTS" />
        </Grid>
        <Grid className="contacts-wrapper" container>
          {this.props.contacts ? (
            this.getContent()
          ) : (
            <div style={{ margin: 'auto' }}>
              <Spinner size={30} />
            </div>
          )}
        </Grid>
      </Grid>
    );
  }
}
const mapStateToProps = state => {
  return {};
};
const mapDispatchToProps = {
  setComposeClick,
};
export default connect(mapStateToProps, mapDispatchToProps)(ContactsPres);
